import { render, staticRenderFns } from "./VariationNumber.vue?vue&type=template&id=db40e234&scoped=true"
import script from "./VariationNumber.vue?vue&type=script&lang=js"
export * from "./VariationNumber.vue?vue&type=script&lang=js"
import style0 from "./VariationNumber.vue?vue&type=style&index=0&id=db40e234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db40e234",
  null
  
)

export default component.exports